import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import localization from 'moment/locale/de'

import { VALVE_DEVICE } from '../../constants/routes'
import { isDefaultValveImage } from '../utilities/helpers'
import {
    DeviceListItem,
    DeviceBatteryIcon,
    DeviceBatteryIconWrapper,
    DeviceBatteryIconText,
    DeviceListItemContent,
    DeviceItemName,
    DevicesListItemCol,
    DeviceListImage,
    ValveListItemInnerContent,
    DeviceMoistureIconWrapper,
    ValveWateringIconText,
    DeviceMoistureIcon
} from '../StyledComponents/Devices/DeviceList'

const batteryGreen = require('../../assets/images/DevicesList/batteryGreen.svg')
const batteryOrange = require('../../assets/images/DevicesList/batteryOrange.svg')
const batteryRed = require('../../assets/images/DevicesList/batteryRed.svg')
const valveImage = require('../../assets/images/DevicesList/valve.png')
const faucetIcon = require('../../assets/images/DevicesList/faucet.png')

class ValveListItem extends Component {
    render() {
        const { device } = this.props
        const { soc } = device

        let batteryIcon = null
        let batteryColor = 'black'
        if (soc < 20) {
            batteryIcon = batteryRed
            batteryColor = 'danger'
        } else if (soc < 50) {
            batteryIcon = batteryOrange
            batteryColor = 'warning'
        } else {
            batteryIcon = batteryGreen
            batteryColor = 'success'
        }

        const image = isEmpty(device.image) ? valveImage : device.image

        return (
            <DevicesListItemCol xs="6" sm="4" md="3">
                <DeviceListItem to={VALVE_DEVICE.replace(':uuid', device.uuid)}>
                    <DeviceListItemContent>
                        <DeviceListImage src={image} contain={isDefaultValveImage(device.image)} />
                        <ValveListItemInnerContent>
                            <DeviceItemName>{device.name}</DeviceItemName>
                            <DeviceMoistureIconWrapper bottom="30">
                                <DeviceMoistureIcon image={faucetIcon} />
                                <ValveWateringIconText>
                                    {`${moment(device.next_irrigation).locale('de', localization).calendar()}`}
                                </ValveWateringIconText>
                            </DeviceMoistureIconWrapper>
                            <DeviceBatteryIconWrapper bottom="20">
                                <DeviceBatteryIcon image={batteryIcon} />
                                <DeviceBatteryIconText textColor={batteryColor}>
                                    {device.soc}%
                                </DeviceBatteryIconText>
                            </DeviceBatteryIconWrapper>
                        </ValveListItemInnerContent>
                    </DeviceListItemContent>
                </DeviceListItem>
            </DevicesListItemCol>
        )
    }
}

export default ValveListItem



// WEBPACK FOOTER //
// ./src/components/Devices/ValveListItem.js